import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { formatCurrencyByLocale } from '../../../utils/currencyUtils';
import { AssetGroups } from '../../../constants/assetGroups';
import AssetUpdateAction from './AssetUpdateAction.js';
import AssetDeleteAction from './AssetDeleteAction.js';

const COLUMNS = ['Name', 'Type', 'Currency', 'Current Balance', 'Growth Rate (%)', 'EOY Balance', 'Actions'];

function mapStateToProps(state) {
  return {
    assetSummary: state.assetInfo.assetSummary,
    assetGroup: state.assetInfo.assetGroup || AssetGroups.TYPE,
    locale: state.currencyInfo.locale,
    currencyRates: state.currencyInfo.currencyRates
  }
}

class AssetSummaryTable extends Component {
  renderRow(r, ridx, ratesLoaded) {
    const unsupported = ratesLoaded && !this.props.currencyRates[r[2]];
    const renderTooltip = (text) => <Tooltip id={`tooltip-${ridx}`}>Updated on {text}</Tooltip>;
    return (
      <OverlayTrigger key={ridx} placement="top" delayShow={300} delayHide={150} overlay={renderTooltip(r[5])}>
        <tr>
          {r.filter((c, cidx) => cidx !== 5).map((c, cidx) =>
            <td key={cidx} style={unsupported ? { opacity: 0.45 } : undefined}>
              {[3, 5].includes(cidx) ? formatCurrencyByLocale(this.props.locale, r[2], c) : c}
            </td>
          )}
          <td key="actions">
            <React.Fragment>
              <AssetUpdateAction iAssetSummaryRow={ridx} disabled={unsupported} />
              <AssetDeleteAction iAssetSummaryRow={ridx} />
            </React.Fragment>
          </td>
        </tr>
      </OverlayTrigger>
    );
  }

  render() {
    const { assetSummary, assetGroup, currencyRates } = this.props;
    const ratesLoaded = Object.keys(currencyRates).length > 0;

    // Flat list for Individual grouping
    if (assetGroup === AssetGroups.INDIVIDUAL) {
      return (
        <Table bordered hover size="sm">
          <thead><tr>{COLUMNS.map(c => <th key={c}>{c}</th>)}</tr></thead>
          <tbody>
            {assetSummary.map((r, ridx) => this.renderRow(r, ridx, ratesLoaded))}
          </tbody>
        </Table>
      );
    }

    // Grouped sections for Type / Currency
    const groupColIdx = assetGroup === AssetGroups.CURRENCY ? 2 : 1;
    const groups = new Map();
    assetSummary.forEach((r, ridx) => {
      const key = r[groupColIdx];
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push({ r, ridx });
    });

    return (
      <Table bordered hover size="sm">
        <thead><tr>{COLUMNS.map(c => <th key={c}>{c}</th>)}</tr></thead>
        <tbody>
          {Array.from(groups.entries()).sort((a, b) => b[1].length - a[1].length).map(([groupName, items]) => (
            <React.Fragment key={groupName}>
              <tr>
                <td colSpan={COLUMNS.length} style={{ background: 'var(--bs-primary)', fontWeight: 600, paddingLeft: '0.75rem', color: '#fff' }}>
                  {groupName}
                </td>
              </tr>
              {items.map(({ r, ridx }) => this.renderRow(r, ridx, ratesLoaded))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    );
  }
}

export default connect(mapStateToProps)(AssetSummaryTable);
